import axios from "axios";
import { getCookie } from "../../getcookie";
const apiUrl = process.env.REACT_APP_API_URL;

const header = {
  "Content-Type": "application/json; charset=UTF-8",
  Accept: "application/json",
  "Access-Control-Allow-Origin": "*", // Required for CORS support to work
  Authorization: getCookie("mawalog"),
};

export const getTripCostListApi = async (params) => {
  try {
    const response = await axios.get(apiUrl + `tripcost`, {
      params: params,
      headers: header,
    });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

export const submitTripCostAPI = async (body) => {
  try {
    const response = await axios.post(apiUrl + `tripcost`, body, {
      headers: header,
    });
    console.log("change", response);
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);

    // Return server error data if available, else generic error
    if (err.response && err.response.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};

export const updateTripCostAPI = async (id, body) => {
  try {
    const response = await axios.put(apiUrl + `tripcost/` + id, body, {
      headers: header,
    });
    console.log("change", response);
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);

    // Return server error data if available, else generic error
    if (err.response && err.response.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};

export const getTripCostEditApi = async (id) => {
  try {
    const response = await axios.get(apiUrl + `tripcost/get/` + id, {
      headers: header,
    });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

export const deleteTripsApi = async (id) => {
  try {
    const response = await axios.delete(apiUrl + `tripcost/delete/` + id, {
      headers: header,
    });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

export const bulkDeleteTripsApi = async (payload) => {
  try {
    const data = Array.isArray(payload) ? { id: payload } : payload;
    const response = await axios.delete(apiUrl + `tripcost/bulkdelete`, {
      data,
      headers: header,
    });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
    if (err.response && err.response.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};

export const getTripCostViewApi = async (id) => {
  try {
    const response = await axios.get(apiUrl + `tripcost/get/` + id, {
      headers: header,
    });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

export const getActualWorkflowApi = async (id) => {
  try {
    const response = await axios.get(apiUrl + `trips/workflow/` + id, {
      headers: header,
    });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

export const getEstimateWorkflowApi = async (id) => {
  try {
    const response = await axios.get(apiUrl + `stop/est_workflow/` + id, {
      headers: header,
    });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

export const getTripDetailApi = async (id) => {
  try {
    const response = await axios.get(apiUrl + `tripcost/trip/` + id, {
      headers: header,
    });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

export const saveAttachmentApi = async (id, body) => {
  try {
    const response = await axios.put(
      apiUrl + `tripcost/attachment/` + id,
      body,
      {
        headers: header,
      }
    );
    console.log("change", response);
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);

    // Return server error data if available, else generic error
    if (err.response && err.response.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};
